import React from "react";
import { parse } from "url";

import ImageWithLoader from "../imageWithLoader";
import { useDevice } from "../../../contexts/deviceContext";
import ExternalLink from "../externalLink";
import styles from "./index.module.scss";

type Props = {
  ogp: {
    description?: string | null;
    image?: string | null;
    title?: string | null;
  };
  url: string;
};

export const LinkBlock: React.FC<Props> = ({ ogp, url }) => {
  const device = useDevice();
  const descriptionMaxLength = device === "mobile" ? 45 : 100;
  const link = () => {
    const parsedUrl = parse(url);
    if (parsedUrl.hostname) {
      return <div className={styles.link}>{parsedUrl.hostname}</div>;
    }

    return <div className={styles.link}>{url}</div>;
  };

  const content = () => {
    if (ogp.description || ogp.image || ogp.title) {
      return (
        <>
          <div className={styles.right}>
            {ogp.title ? <div className={styles.title}>{ogp.title}</div> : null}
            {ogp.description ? (
              <div className={styles.description}>
                {ogp.description.length > descriptionMaxLength
                  ? ogp.description.substr(0, descriptionMaxLength) + "..."
                  : ogp.description}
              </div>
            ) : null}
            {link()}
          </div>
          {ogp.image && device !== "mobile" ? (
            <div className={styles.left}>
              <ImageWithLoader className={styles.image} src={ogp.image} />
            </div>
          ) : null}
        </>
      );
    } else {
      return <div className={styles.mainLink}>{url}</div>;
    }
  };

  return (
    <div className={styles.container}>
      <ExternalLink to={url}>
        <div className={styles.wrapper}>{content()}</div>
      </ExternalLink>
    </div>
  );
};
